import { render, staticRenderFns } from "./PMDashboardDropdownSelector.vue?vue&type=template&id=a64bce48&scoped=true&"
import script from "./PMDashboardDropdownSelector.vue?vue&type=script&lang=js&"
export * from "./PMDashboardDropdownSelector.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardDropdownSelector.vue?vue&type=style&index=0&id=a64bce48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64bce48",
  null
  
)

export default component.exports